module.exports = __webpack_public_path__ + "img/vertical_7_5_5012.a6fe927f.png";